import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-text">
          <h2>Transforma tu futuro financiero</h2>
          <p>Find Balance es tu aliado para una gestión financiera sin estrés. Obtén una visión clara de tus ahorros, gastos e inversiones, y toma el control de tu patrimonio con confianza.</p>
          <p>Descubre cómo nuestras herramientas intuitivas te motivarán a alcanzar tus metas, paso a paso. ¡Es hora de invertir en tu tranquilidad!</p>
          <a href="https://app.findbalance.es" className="btn" data-event="about_cta">Controla tus finanzas totalmente gratis</a>
        </div>
      </div>
    </section>
  );
}

export default About;